/* libs */
import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import { asField } from "informed";
import axios from "axios";
import moment from "moment";

import { SimpleSelectInput, CollectionAccordion } from "./index";
import validatehoc from "../Validator";
import GetItem from "../../../helpers/dataProviders/getItem";
import parseAppKey from "../../../helpers/routeHelpers/parseAppKey";

class BrushfireAttendeeDataMapper extends Component {
	constructor(props) {
		super(props);
		this.state = {
			minimizePlaceholder: false,
			eventData: [],
			eventOptions: [],
			expandedFieldIndex: [],
			fieldData: {},
			fieldOptions: {},
			attendeeTypeData: {},
			isLoading: false,
			showAdvanced: false,
			brushfireApiKey: null,
			brushfireAccessKey: null,
		};
		this.appKey = parseAppKey();
	}

	componentDidMount() {
		if (
			(this.props.formValues && this.props.formValues.brushfireApiKey) ||
			this.props.formValues.brushfireAccessKey
		) {
			this.setState(
				{
					brushfireApiKey: this.props.formValues.brushfireApiKey,
					brushfireAccessKey: this.props.formValues.brushfireAccessKey,
				},
				() => {
					this.getBrushfireEvents(true);
				}
			);
		} else {
			this.getBrushfireEvents(true);
		}
	}

	componentDidUpdate(prevProps) {
		if (
			(prevProps.formValues && prevProps.formValues.brushfireApiKey !== this.props.formValues.brushfireApiKey) ||
			prevProps.formValues.brushfireAccessKey !== this.props.formValues.brushfireAccessKey
		) {
			this.setState(
				{
					brushfireApiKey: this.props.formValues.brushfireApiKey,
					brushfireAccessKey: this.props.formValues.brushfireAccessKey,
				},
				() => {
					this.getBrushfireEvents();
				}
			);
		}
	}

	generateBrushfireClient = () => {
		let brushfireApiKey = this.state.brushfireApiKey;
		if (brushfireApiKey && brushfireApiKey.match(/^[a-zA-Z0-9]{16}$/)) {
			const authHash = btoa(`${brushfireApiKey}:`);
			return axios.create({
				baseURL: "https://api.brushfire.com/",
				//timeout: 10000,
				headers: {
					Authorization: `Basic ${authHash}`,
					Accept: "application/json",
					"Content-Type": "application/json",
					"api-version": "2019-01-17",
				},
			});
		}
		return null;
	};

	getBrushfireEvents = (buildFields = false) => {
		let bfClient = this.generateBrushfireClient();
		if (bfClient) {
			bfClient
				.get("/events")
				.then(data => {
					let eventData = data.data;
					let eventOptions = [];
					eventData.forEach(event => {
						eventOptions.push({ key: event.EventNumber, value: event.EventNumber, label: event.Title });
					});
					this.setState({ eventData, eventOptions }, () => {
						if (buildFields) {
							let value = this.props.fieldApi.getValue();
							value.forEach(event => {
								this.getBrushfireFieldsForEvent(event.eventNumber);
							});
						}
					});
				})
				.catch(error => {});
		}
	};

	addEvent = e => {
		e.preventDefault();
		e.stopPropagation();
		const { fieldApi } = this.props;
		let value = fieldApi.getValue();
		let newValue;
		if (value) {
			newValue = value.concat();
		} else {
			newValue = [];
		}
		newValue.push({ eventNumber: "", eventTitle: "", attendeeTypes: [], optionIds: {} });
		fieldApi.setValue(newValue);
		fieldApi.setTouched(true);
		this.setState({ expandedIndex: newValue.length - 1 });
	};

	changeEvent = (e, i) => {
		let value = e.target.value;
		let { fieldApi } = this.props;
		const { eventData } = this.state;
		const event = eventData.find(evt => evt.EventNumber.toString() === value);
		if (event) {
			let fieldValue = fieldApi.getValue().concat();
			fieldValue[i] = { eventNumber: value, eventTitle: event.Title, attendeeTypes: [], optionIds: {} };
			fieldApi.setValue(fieldValue);
			fieldApi.setTouched(true);
			this.getBrushfireFieldsForEvent(value);
		}
	};

	changeFieldValue = (e, i, fieldIndex, propertyName) => {
		let value = e.target.value;
		let { fieldApi } = this.props;
		let fieldValue = fieldApi.getValue().concat();
		fieldValue[i][propertyName] = value;
		fieldApi.setValue(fieldValue);
		fieldApi.setTouched(true);
	};

	toggleData = (i, currentState, value, propertyName) => {
		let { fieldApi } = this.props;
		let fieldValue = fieldApi.getValue().concat();
		if (currentState) {
			var index = fieldValue[i][propertyName].indexOf(value);
			if (index !== -1) fieldValue[i][propertyName].splice(index, 1);
		} else {
			fieldValue[i][propertyName].push(value);
		}
		fieldApi.setValue(fieldValue);
		fieldApi.setTouched(true);
	};

	toggleOptionData = (i, currentState, value, propertyName, fieldIndex) => {
		let { fieldApi } = this.props;
		let fieldValue = fieldApi.getValue().concat();
		if (currentState) {
			var index = fieldValue[i][propertyName][fieldIndex].indexOf(value);
			if (index !== -1) {
				fieldValue[i][propertyName][fieldIndex].splice(index, 1);
				if (fieldValue[i][propertyName][fieldIndex].length === 0) {
					var indexToRemove = fieldValue[i][propertyName].indexOf(fieldIndex);
					if (indexToRemove !== -1) {
						fieldValue[i][propertyName].splice(indexToRemove, 1);
					}
				}
			}
		} else {
			if (!fieldValue[i][propertyName][fieldIndex]) {
				fieldValue[i][propertyName][fieldIndex] = [];
			}
			fieldValue[i][propertyName][fieldIndex].push(value);
		}
		fieldApi.setValue(fieldValue);
		fieldApi.setTouched(true);
	};

	getBrushfireFieldsForEvent = eventNumber => {
		let bfClient = this.generateBrushfireClient();
		if (bfClient) {
			bfClient
				.get(`/events/${eventNumber}/fields?fieldType=Attendees&accessKey=${this.state.brushfireAccessKey}`)
				.then(data => {
					let fieldData = Object.assign({}, this.state.fieldData);
					fieldData[eventNumber] = data.data;
					//get attendeeTypes
					bfClient
						.get(`/events/${eventNumber}/types`)
						.then(typeData => {
							let attendeeTypeData = Object.assign({}, this.state.attendeeTypeData);
							attendeeTypeData[eventNumber] = typeData.data;
							this.setState({ fieldData, attendeeTypeData });
						})
						.catch(error => {});
				})
				.catch(error => {});
		}
	};

	deleteCollection = index => {
		const { fieldApi } = this.props;
		let newValue = fieldApi.getValue().concat();
		newValue.splice(index, 1);
		fieldApi.setValue(newValue);
		fieldApi.setTouched(true);
	};

	render() {
		const { fieldState, placeholder, isRequired } = this.props;
		const { value } = fieldState;
		const { eventOptions, brushfireApiKey, fieldData, attendeeTypeData } = this.state;
		return (
			<Fragment>
				{brushfireApiKey ? (
					<div>
						<div>
							<div className="btn-circle m-right" title="Add An Event" onClick={e => this.addEvent(e)}>
								<i className="fal fa-plus icon"></i>
							</div>
							<h4 className="collection-title">{placeholder}</h4>
						</div>
						<div className="collection-group">
							{value &&
								value.length > 0 &&
								value.map((event, i) => {
									let title = isRequired ? "* " : "";
									title += event.eventTitle ? event.eventTitle : "Pick an Event";
									const { attendeeTypes, optionIds } = event;

									return (
										<CollectionAccordion
											key={i}
											title={title}
											expanded={this.state.expandedIndex === i}
											index={i}
											toggleCollectionItem={expandedIndex => this.setState({ expandedIndex })}
											deleteCollection={this.deleteCollection}
											totalCount={value.length}
										>
											<div className="collection-item-properties">
												{eventOptions && (
													<div>
														<SimpleSelectInput
															id="eventNumber"
															placeholder="Event"
															values={eventOptions}
															value={event.eventNumber}
															onChange={e => {
																this.changeEvent(e, i);
															}}
														/>
													</div>
												)}
												{fieldData[event.eventNumber] && (
													<div>
														<div className="collection-group">
															{attendeeTypeData[event.eventNumber] && (
																<div>
																	<h3 className="ta-center">Attendee Types</h3>

																	{attendeeTypeData[event.eventNumber].map(
																		attendeeType => {
																			let active = attendeeTypes.includes(
																				attendeeType.Id
																			);
																			return (
																				<div
																					key={attendeeType.Id}
																					className={`on-off-item ${
																						active ? "on" : "off"
																					}`}
																					onClick={() =>
																						this.toggleData(
																							i,
																							active,
																							attendeeType.Id,
																							"attendeeTypes"
																						)
																					}
																				>
																					<div className="on-off-switch"></div>
																					{attendeeType.Name}
																				</div>
																			);
																		}
																	)}
																</div>
															)}
															{fieldData[event.eventNumber] && (
																<div>
																	<h3 className="ta-center">Field Options</h3>
																	{fieldData[event.eventNumber].map(fieldItem => {
																		let jsx = [];
																		if (
																			fieldItem.Options &&
																			fieldItem.Options.length
																		) {
																			jsx.push(
																				<div className="field-group">
																					<h4>{fieldItem.Label}</h4>
																				</div>
																			);
																			fieldItem.Options.forEach(fieldOption => {
																				let active =
																					optionIds[fieldItem.Id] &&
																					optionIds[fieldItem.Id].includes(
																						fieldOption.Id
																					);
																				jsx.push(
																					<div
																						key={fieldOption.Id}
																						className={`on-off-item ${
																							active ? "on" : "off"
																						}`}
																						onClick={() =>
																							this.toggleOptionData(
																								i,
																								active,
																								fieldOption.Id,
																								"optionIds",
																								fieldItem.Id
																							)
																						}
																					>
																						<div className="on-off-switch"></div>
																						{fieldOption.Label}
																					</div>
																				);
																			});
																			return jsx;
																		} else {
																			return null;
																		}
																	})}
																</div>
															)}
														</div>
													</div>
												)}
											</div>
										</CollectionAccordion>
									);
								})}
						</div>
					</div>
				) : (
					<div className="alert alert-warning">First, Add Your Brushfire Api Key</div>
				)}
			</Fragment>
		);
	}
}

BrushfireAttendeeDataMapper.propTypes = {
	propertyKey: PropTypes.string,
	field: PropTypes.string,
	id: PropTypes.string,
	placeholder: PropTypes.string,
	autocomplete: PropTypes.string,
	values: PropTypes.array,
	isRequired: PropTypes.bool,
	minLength: PropTypes.number,
	maxLength: PropTypes.number,
	validationRegex: PropTypes.string,
	regexMessage: PropTypes.string,
	defaultEnabled: PropTypes.bool,
	fieldState: PropTypes.object,
	appKey: PropTypes.string,
	fieldApi: PropTypes.object,
	formApi: PropTypes.object,
	formValues: PropTypes.object,
};

const Wrapper = validatehoc(
	asField(({ fieldState, ...props }) => <BrushfireAttendeeDataMapper fieldState={fieldState} {...props} />),
	"array"
);

export default Wrapper;
